"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.8 400.8",
    width: "100%",
    height: "100%",
    children: (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M265.9,226.7c-3.9,1.5-7.9,2.2-12,2.1c-3,7.6-9.1,14-17.2,17.3c-4.4,1.8-9,2.5-13.5,2.2l0.6,43.7l37.2,59.7\n\t\tL281,316l40.3-6.7L265.9,226.7z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M191.7,254.8c-8.8,0-16.7-3.7-22.4-9.6c-7.5,3.2-16.3,3.5-24.4,0.1c-1.4-0.5-2.5-1.3-3.8-1.9V376l36.8-17.7\n\t\tl36.8,17.7V246.5c-0.4-0.1-0.8-0.3-1.3-0.5C207.7,251.5,200,254.8,191.7,254.8z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M149.9,233.3c9.2,3.9,19.7-0.3,23.6-9.4c0.1,9.9,8.1,17.8,18,17.8c9.1,0,16.6-6.8,17.9-15.5\n\t\tc4.5,7.6,14,11.1,22.4,7.6c9.2-3.8,13.7-14.2,10-23.4c7.1,6.9,18.5,6.9,25.5-0.1c6.5-6.5,7-16.5,1.7-23.6\n\t\tc8.6,2.3,17.7-2.1,21.3-10.4c3.9-9.2-0.3-19.7-9.4-23.6c9.9-0.1,17.8-8.1,17.8-18c0-9.1-6.8-16.6-15.5-17.9\n\t\tc7.6-4.5,11.1-14,7.6-22.4c-3.8-9.2-14.2-13.7-23.4-10c6.9-7.1,6.9-18.5-0.1-25.5c-6.5-6.5-16.5-7-23.6-1.7\n\t\tc2.3-8.6-2.1-17.7-10.4-21.3c-9.2-3.9-19.7,0.3-23.6,9.4c-0.1-9.9-8.1-17.8-18-17.8c-9.1,0-16.6,6.8-17.9,15.5\n\t\tc-4.5-7.6-14-11.1-22.4-7.6c-9.2,3.8-13.7,14.2-10,23.4c-7.1-6.9-18.5-6.9-25.5,0.1c-6.5,6.5-7,16.5-1.7,23.6\n\t\tc-8.6-2.3-17.7,2.1-21.3,10.4c-3.9,9.2,0.3,19.7,9.4,23.6c-9.9,0.1-17.8,8.1-17.8,18c0,9.1,6.8,16.6,15.5,17.9\n\t\tc-7.6,4.5-11.1,14-7.6,22.4c3.8,9.2,14.2,13.7,23.4,10c-6.9,7.1-6.9,18.5,0.1,25.5c6.5,6.5,16.5,7,23.6,1.7\n\t\tC137.2,220.6,141.6,229.8,149.9,233.3z M114,134.7c0-42.9,34.7-77,77.6-77.6c42-0.5,77.1,34.4,77.6,77.6\n\t\tc0.5,42.9-34.7,77.6-77.6,77.6C148.8,212.3,114,177.5,114,134.7z"
      }), (0, jsx_runtime_1.jsx)("ellipse", {
        transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -39.06 174.971)",
        fill: "currentColor",
        cx: "191.7",
        cy: "134.6",
        rx: "60.4",
        ry: "60.4"
      })]
    })
  });
};

exports.default = Icon;